/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Search_PlaceholderInputs */

const en_nav_search_placeholder = /** @type {(inputs: Nav_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search for builds...`)
};

const es_nav_search_placeholder = /** @type {(inputs: Nav_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busca builds...`)
};

/**
* | output |
* | --- |
* | "Search for builds..." |
*
* @param {Nav_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
const nav_search_placeholder = /** @type {((inputs?: Nav_Search_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Search_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_search_placeholder(inputs)
	return en_nav_search_placeholder(inputs)
});
export { nav_search_placeholder as "nav.search.placeholder" }